import { Actions } from './units-settings.actions'
import { fromJS } from 'immutable'
import * as UnitsSettingsTypes from './units-settings.types'

export const initialState = fromJS<any>({
  isLoading: false,
  validationErrors: {},
  data: {},
})

export function unitsSettingsReducer(state = initialState, action: Actions) {
  switch (action.type) {
    case UnitsSettingsTypes.UPDATE_UNITS_SETTINGS_REQUEST: {
      return state.set('isLoading', true)
    }

    case UnitsSettingsTypes.UPDATE_UNITS_SETTINGS_SUCCESS: {
      return state.set('isLoading', false)
    }

    case UnitsSettingsTypes.UPDATE_UNITS_SETTINGS_FAILURE: {
      return state.set('isLoading', false)
    }

    case UnitsSettingsTypes.FETCH_UNITS_SETTINGS_REQUEST: {
      return state.set('isLoading', true)
    }

    case UnitsSettingsTypes.FETCH_UNITS_SETTINGS_SUCCESS: {
      return state.set('isLoading', false).set('data', fromJS(action.payload))
    }

    case UnitsSettingsTypes.FETCH_UNITS_SETTINGS_FAILURE: {
      return state.set('isLoading', false)
    }

    case UnitsSettingsTypes.UPDATE_FIELD:
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case UnitsSettingsTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
